

//Animation of team members' photos

const animAgencyPage = {

    init () {

        let agencyPage = document.getElementById('agencypage');

        if(agencyPage){

            let membersPhotos = document.querySelectorAll('.team-member-photo');
            let membersNames = document.querySelectorAll('.team-member-name');
    
            membersNames[0].classList.add('active');
            membersNames[0].classList.add('visible');
            membersPhotos[0].classList.add('active');
    
            for(let i = 1; i < membersNames.length ; i++){
                membersNames[i].classList.add('notactive');
            }
    
            for(let i =0; i < membersPhotos.length ; i++){
                
                membersPhotos[i].addEventListener('click', e => {
    
                    if(membersNames[i].classList.contains('active') == false){
                        
                        for(let i = 0; i < membersPhotos.length ; i++){
    
                            membersNames[i].classList.remove('active');
                            membersNames[i].classList.remove('visible');
                    
                            membersPhotos[i].classList.remove('active');
                    
                            setTimeout(function () {
                                membersNames[i].classList.add('notactive');
                            }, 200);
    
                        }
                        membersPhotos[i].classList.add('active');
    
                        setTimeout(function () {
                            membersNames[i].classList.remove('notactive');
                            membersNames[i].classList.add('active');
                            setTimeout(function () {
                                membersNames[i].classList.add('visible');
                            }, 200);
                            
                        }, 200);
                        
    
    
                    }
    
                })
            }

        }


    }
}

export default animAgencyPage;